import React from 'react';

import './styles.css';

import { FaSearch } from 'react-icons/fa';

function SearchBar(props) {
    function verifyKey(e) {
        if (e.key === 'Enter')
            props.onClick(e)
    }
    
    return (
        <div className='search-bar'>
            <label htmlFor='search-bar-input'><FaSearch /></label>
            <input
                type='text'
                name="search-bar"
                id='search-bar-input'
                placeholder={props.placeholder}
                onKeyUp={verifyKey}
                onChange={props.onChange}
                value={props.value}
            />
            <button onClick={props.onClick}>Buscar</button>
        </div>
    )
}

export default SearchBar;